import React from "react";
import { speakers } from "../../data/SiteData";
function Speakers(props) {
  return (
    <section id="speakers">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <span>Team</span>
          <h2>Team</h2>
          <p>
            Black Box Software Solutions’ well-experienced Software Engineers
          </p>
        </div>

        <div class="row">
          {speakers.map((item) => {
            return (
              <div class="col-lg-4 col-md-6">
                <div class="speaker" data-aos="fade-up" data-aos-delay="100">
                  <img src={item.image} alt="Speaker 1" class="img-fluid" />
                  <div class="details">
                    <h3>
                      <a href={item.website}>{item.name}</a>
                    </h3>
                    <p>{item.title}</p>
                    <div class="social">
                      <a href="">
                        <i class="bi bi-twitter"></i>
                      </a>
                      <a href="">
                        <i class="bi bi-facebook"></i>
                      </a>
                      <a href="">
                        <i class="bi bi-instagram"></i>
                      </a>
                      <a href="">
                        <i class="bi bi-linkedin"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Speakers;
